import React from "react";

import ContentAdminCategoriaRegistro from "./ContentAdminCategoriaRegistro";

const AdminCategoriaRegistro = () => {
  return (
    <>
      <ContentAdminCategoriaRegistro />
    </>
  );
};

export default AdminCategoriaRegistro;